import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export type TemplateSubMode = 'ids' | 'tags';

type Props = {
    value: TemplateSubMode;
    onChange: (nextMode: TemplateSubMode) => void;
};

/**
 * Sub-mode switch for Template mode: pick individual templates (ids) or pick tags whose
 * matching templates are resolved dynamically at send/post time.
 */
const TemplateModeToggle = (props: Props) => {
    const { value, onChange } = props;

    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            color="primary"
            value={value}
            onChange={(_, nextMode: TemplateSubMode | null) => {
                if (nextMode) {
                    onChange(nextMode);
                }
            }}
        >
            <ToggleButton value="ids">Pick Templates</ToggleButton>
            <ToggleButton value="tags">Pick Tags</ToggleButton>
        </ToggleButtonGroup>
    );
};

export default TemplateModeToggle;
